/**
 * クエリパラメータからクエリ文字列を生成する
 * @param params - クエリパラメータのオブジェクト
 * @returns クエリ文字列
 */
export const buildQueryString = (params?: Record<string, unknown>): string => {
  if (!params || Object.keys(params).length === 0) return ''
  const sortedKeys = Object.keys(params).sort()
  return sortedKeys
    .map((key) => `${key}=${encodeURIComponent(String(params[key]))}`)
    .join('&')
}
